import { render, staticRenderFns } from "./iCardVertical.vue?vue&type=template&id=1b2e7ebe&scoped=true"
import script from "./iCardVertical.vue?vue&type=script&lang=js"
export * from "./iCardVertical.vue?vue&type=script&lang=js"
import style0 from "./iCardVertical.vue?vue&type=style&index=0&id=1b2e7ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2e7ebe",
  null
  
)

export default component.exports